import React from 'react';
import {
  FilledInputProps,
  InputAdornment,
  TextFieldProps,
} from '@mui/material';
import { StyledInput } from './input.styles';
import { useTheme } from '@mui/material';
import Flex from '@components/Flex/Flex';
import { Lock } from '@assets/svg';

export interface InputProps {
  locked?: boolean;
}

const Input: React.FC<InputProps & TextFieldProps> = ({
  InputProps,
  disabled,
  locked = false,
  ...props
}) => {
  const theme = useTheme();

  return (
    <StyledInput
      disabled={locked || disabled}
      InputProps={
        {
          ...InputProps,
          disableUnderline: true,
          endAdornment: locked ? (
            <Flex mr={2}>
              <InputAdornment position='end'>
                <Lock color={theme.palette.grey.A100} />
              </InputAdornment>
            </Flex>
          ) : (
            InputProps?.endAdornment
          ),
        } as Partial<FilledInputProps>
      }
      variant='filled'
      {...props}
    />
  );
};

export default Input;
